import { apiUrl as getApiUrl } from "./runtimeConfig";
export const getProfileImageUrl = (image: string): string => {
  const apiUrl = getApiUrl();
  return `${apiUrl}/files/profile/${image}`;
};

export const getOrgLogoUrl = (logo: string): string => {
  const apiUrl = getApiUrl();
  return `${apiUrl}/files/logo/${logo}`;
};
